import clsx from 'clsx'
import times from 'lodash/times'
import React, { FC, ReactNode } from 'react'

import SVGStar from '@Assets/SVG/Star'
import { Abundance } from '@Components/Badges'

import styles from './starRating.module.scss'

const StarPartial: FC<{ inactiveBackgroundColor?: string, inactiveForegroundColor?: string }> = ({ inactiveBackgroundColor, inactiveForegroundColor }) => (
  <div className={styles.partialStar}>
    <div className={styles.starBackGround}>
      <div className={styles.IconWrapper}>
        <SVGStar style={inactiveBackgroundColor ? { fill: inactiveBackgroundColor } : {}} />
      </div>
    </div>
    <div className={styles.starForeGround}>
      <div className={styles.IconWrapper}>
        <SVGStar style={inactiveForegroundColor ? { stroke: inactiveForegroundColor, fill: 'transparent' } : {}} />
      </div>
    </div>
  </div>
)

interface StarRatingProps {
  abundance?: ReactNode
  activeColor?: string
  className?: string
  /** Range 1-5, can have decimals */
  inactiveBackgroundColor?: string
  inactiveForegroundColor?: string
  rating: number
}

const StarFull: FC<{ activeColor?: string }> = ({ activeColor }) => (
  <div className={styles.partialStar}>
    <div className={styles.IconWrapper}>
      <SVGStar className={clsx(styles.starFull)} style={activeColor ? { fill: activeColor } : {}} />
    </div>
  </div>
)

export const StarRating: FC<StarRatingProps> = ({
  abundance,
  activeColor,
  className,
  inactiveBackgroundColor,
  inactiveForegroundColor,
  rating,
}: StarRatingProps) => (
  <div className={clsx(className, styles.starRating)}>
    {times(5, (count) => {
      const current = rating - count

      if (current >= 1) {
        return <StarFull key={count} activeColor={activeColor} />
      }

      return <StarPartial key={count} inactiveBackgroundColor={inactiveBackgroundColor} inactiveForegroundColor={inactiveForegroundColor} />
    })}
    {abundance && <Abundance>{abundance}</Abundance>}
  </div>
)
